import React, { useEffect, useMemo, useState } from 'react';
import Detailpart1 from './Detailpart1';
import ChallengeAndSolution from './ChallengeAndSolution';
import casedata from '../CaseList/casedata.json';
import { useLocation, useParams } from 'react-router-dom';

const CaseDetails = () => {
  const [filteredCaseData, setFilteredCaseData] = useState(casedata[0]);
  const location = useLocation();
  const params = useParams();

  const resolvedCaseId = useMemo(() => {
    const fromState = location.state?.id;
    if (typeof fromState === 'number') return fromState;
    if (typeof fromState === 'string') {
      const parsed = Number.parseInt(fromState, 10);
      return Number.isFinite(parsed) ? parsed : undefined;
    }

    if (typeof params.id === 'string') {
      const parsed = Number.parseInt(params.id, 10);
      return Number.isFinite(parsed) ? parsed : undefined;
    }

    return undefined;
  }, [location.state, params.id]);

  useEffect(() => {
    if (resolvedCaseId) {
      const filteredData = casedata.find((item) => item.id === resolvedCaseId);
      setFilteredCaseData(filteredData ?? casedata[0]);
      return;
    }

    setFilteredCaseData(casedata[0]);
  }, [resolvedCaseId]);

  return (
    <>
      <Detailpart1 caseData={filteredCaseData} />
      <ChallengeAndSolution casedata={filteredCaseData} />
    </>
  )
}

export default CaseDetails
